import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import {uuidZodValidator} from "@vesta/global-common-typescript/validators/zodValidators";
import {BlogsWorkspaceCapabilityUdoTemplateKey} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/blogsWorkspaceCapability/domain/BlogsWorkspaceCapabilityUdoTemplateKey";
import type {WorkspaceCapabilityType} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/workspaceCapabilities/domain/WorkspaceCapabilityType";
import type {WorkspaceCapabilityUdoTemplateConfiguration} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/workspaceCapabilities/domain/WorkspaceCapabilityUdoTemplateConfiguration";
import {z as zod} from "zod";
export type BlogsWorkspaceCapabilityUdoBindings = WorkspaceCapabilityUdoTemplateConfiguration<WorkspaceCapabilityType.blogs> & {
    fixedUdoTemplates: {
        [BlogsWorkspaceCapabilityUdoTemplateKey.blog]: {
            udoAdditionalColumnIds: {
                authorImageId: Uuid;
                authorName: Uuid;
                authorRole: Uuid;
                content: Uuid;
                description: Uuid;
                downloadLinks: Uuid;
                featuredImageId: Uuid;
                metaDescription: Uuid;
                metaTitle: Uuid;
                primaryTag: Uuid;
                renderedContent: Uuid;
                scheduledPublishAt: Uuid;
                scheduleErrorDetail: Uuid;
                scheduleStatus: Uuid;
                secondaryTags: Uuid;
                slug: Uuid;
                status: Uuid;
                timeToRead: Uuid;
                title: Uuid;
            };
        };
    };
};
export const blogsWorkspaceCapabilityUdoBindingsValidator = zod.strictObject({
    fixedUdoTemplates: zod.strictObject({
        [BlogsWorkspaceCapabilityUdoTemplateKey.blog]: zod.strictObject({
            udoAdditionalColumnIds: zod.strictObject({
                authorImageId: uuidZodValidator,
                authorName: uuidZodValidator,
                authorRole: uuidZodValidator,
                content: uuidZodValidator,
                description: uuidZodValidator,
                downloadLinks: uuidZodValidator,
                featuredImageId: uuidZodValidator,
                metaDescription: uuidZodValidator,
                metaTitle: uuidZodValidator,
                primaryTag: uuidZodValidator,
                renderedContent: uuidZodValidator,
                scheduleErrorDetail: uuidZodValidator,
                scheduleStatus: uuidZodValidator,
                scheduledPublishAt: uuidZodValidator,
                secondaryTags: uuidZodValidator,
                slug: uuidZodValidator,
                status: uuidZodValidator,
                timeToRead: uuidZodValidator,
                title: uuidZodValidator,
            }),
            udoTemplateId: uuidZodValidator,
        }),
    }),
}) satisfies zod.ZodType<BlogsWorkspaceCapabilityUdoBindings>;
